import axios from "axios";
import {APIBASE, RELOADORDERSALLMINUTES} from "../../config/Pfalzmarkt.config";
import {useStore} from "../../store/store";
import {useEffect, useState} from "react";

const ApiFunctions = ({url, mappingFunction, timer = null}) => {
    const [globalState, dispatch] = useStore();
    const [varInterval, setInterval] = useState(0);
    const doApiCall = async (url: String, mappingFunction: Function) => {

        const header = "Authorization: Bearer " + localStorage.getItem("token");
        try {
            const response = await axios.get(
                APIBASE + url, {headers: header}
            );
            const data = await response.data;
            mappingFunction(data);

        } catch (err) {
            if (401 === err.response.status) {
                dispatch('IS_401_ERROR', true);
                dispatch('SET_AUTHTOKEN', null);
            }
            console.log(err.message); // Todo: Errorhandling
            //        }
        }
    }



    useEffect(() => {
        doApiCall(url, mappingFunction);

    }, [globalState.token, url]);


}


export default ApiFunctions